var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default",null,{"page":_vm.page,"list":_vm.list,"total":_vm.total,"loading":_vm.loading,"errors":_vm.errors,"onPageChange":_vm.onPageCahnge})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }